import React, { ReactNode } from 'react';

/* COMPONENTES */
import { Container, Grid, Typography, Paper, IconButton, Box } from '@mui/material';
import BotaoAdicionar from '../../componentes/botoes/Adicionar.tsx';
import TableFilter, { ESTATUSFILTER, ETIPOFILTER, IPropsFilterObj } from '../tabelas/TableFilter.tsx';
import { IEntidadesData } from '../../servicos/entidades/Entidades_FrontAPI.ts';
import { ETABLE, HeadCell, ITableFilter, ITablePaginacao, Order } from '../tabelas/ITabelas.ts';
import TableListaPaginada from '../tabelas/TableListaPaginada.tsx';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { isNull, isUndefined } from 'lodash';
import { IProgramasData } from 'src/servicos/programas/Programas_FrontAPI.ts';
import { User } from 'firebase/auth';
import { useAppContextoReact } from '../../servicos/app/AppContextoReact';

interface IListComponentProps {
	titulo: string;
	/* Adicionar */
	addHandleAdd: () => Promise<void>;
	addUrl: string;
	addEhNovaJanela: boolean;
	/* Filtrar */
	fltVisivel?: boolean;
   	fltTipoForm?: ETIPOFILTER
	fltFilterList?: string[]
	fltFilterDefault?:IPropsFilterObj
	fltStatus?: ESTATUSFILTER
	fltCallback?: (dataFilter:IPropsFilterObj) => Promise<void>
	/* Lista */
	lstTipo: ETABLE;
	lstListaPaginada: IEntidadesData[]|IProgramasData[]|User[];
	lstPaginacao?: ITablePaginacao;
	lstPageNumber?: number;
	lstRowsPerPage?: number;
	lstRowsPerPageOptions?: number[];
	lstSetup: HeadCell[];
	lstHandleEdit: (props: IEntidadesData) => Promise<void>;
	lstHandleView?: (props: IEntidadesData) => Promise<void>;
	lstHandleDelete: (fieldId:string, fieldName:string) => Promise<void>;
	lstFieldID: string;
	lstFieldName: string;
	lstCallback?: (rowsNum: number, pageNum: number, orderBy: string, order: Order) => Promise<void>;
	lstCallbackFilter?: (event: React.MouseEvent<unknown>, filter: ITableFilter, orderBy?: string) => Promise<void>;
	/* Ordenação herdada */
	lstOrderHeranca?: Order
	lstOrderByHeranca?: string;
	/* Outros */
	children: ReactNode;
}

const ListComponent: React.FC<IListComponentProps> = (ListComponentProps) => {

	const appContext = useAppContextoReact();

	const [userRoleAdmin, setUserRolerAdmin] = React.useState<boolean|null|undefined>(null);

	const isAcao = ListComponentProps.lstTipo === ETABLE.GENERO || ListComponentProps.lstTipo === ETABLE.USER || ListComponentProps.lstTipo === ETABLE.PRODUTORA;

	

	React.useEffect(() =>
	{
		setUserRolerAdmin(appContext.permissao.administrador)
	},[appContext])

	const lstActionIsView = [
		{
			componentFunction: (props: any) => (
				<IconButton size="small" color="primary" title="Visualizar item" aria-label="Visualizar" onClick={() => ListComponentProps.lstHandleView(props)}><VisibilityIcon/></IconButton>
			)
		},
		{
			componentFunction: (props: any) => (				
				<IconButton size="small" color="primary" title="Editar item" aria-label="Editar" onClick={() => ListComponentProps.lstHandleEdit(props)}><EditIcon/></IconButton>				
			)
		},
		{
			componentFunction: (props: any) => (
				<IconButton size="small" color="error" title="Excluir item" aria-label="Excluir" onClick={() => ListComponentProps.lstHandleDelete(props[ListComponentProps.lstFieldID], props[ListComponentProps.lstFieldName])}><DeleteIcon/></IconButton>
			)
		}
	];
	const lstAction = [
		{
			componentFunction: (props: any) => (				
				<IconButton size="small" color="primary" title="Editar item" aria-label="Editar" onClick={() => ListComponentProps.lstHandleEdit(props)}><EditIcon/></IconButton>				
			)
		},
		{
			componentFunction: (props: any) => (
				<IconButton size="small" color="error" title="Excluir item" aria-label="Excluir" onClick={() => ListComponentProps.lstHandleDelete(props[ListComponentProps.lstFieldID], props[ListComponentProps.lstFieldName])}><DeleteIcon/></IconButton>
			)
		}
	];
	const lstActionVisualizar = [
		{
			componentFunction: (props: any) => (
				<IconButton size="small" color="primary" title="Visualizar item" aria-label="Visualizar" onClick={() => ListComponentProps.lstHandleView(props)}><VisibilityIcon/></IconButton>
			)
		}
	];

	return (
		<>
		<Container>
			<Grid container spacing={2} flexDirection={'row-reverse'}>
				<Grid item xs={12} sx={{ marginBottom:"1rem" }}>
					<Typography component={'span'} variant={'h1'}>{ListComponentProps.titulo}</Typography>
				</Grid>
				<Grid item xs={12} container position={'fixed'} flexDirection={'row-reverse'} zIndex={1}>
					{/* <Paper variant='elevation' sx={{ p:1, position:"absolute" }}> */}
					<Box sx={{ position: "absolute" }}>
						{
							userRoleAdmin &&
								<BotaoAdicionar
									url={ListComponentProps.addUrl}
									ehNovaJanela={ListComponentProps.addEhNovaJanela}
									handleClick={() => ListComponentProps.addHandleAdd()}
									// sxProps={{ position:"absolute", left:"3.5rem", top:"4rem" }}
								/>
						}
						{ ListComponentProps.fltVisivel &&
						<>
							<TableFilter
								filterDefault={ListComponentProps.fltFilterDefault}
								// sxFiltrar={{ position:"absolute", left:"7.5rem", top:"4rem" }}
								sxFiltrar={{ ml:"0.5rem" }}
								tipoForm={ListComponentProps.fltTipoForm}
								status={ListComponentProps.fltStatus}
								filterList={ListComponentProps.fltFilterList}
								callback={ListComponentProps.fltCallback}
							/>
						</>
						}
					</Box>
				</Grid>
				<Grid item xs={12}>
					<Paper variant='outlined' sx={{ p:2, display:'flex', flexDirection:'column' }} id={'CCContainerListaPaginada'}>
						<TableListaPaginada
							tipo={ListComponentProps.lstTipo}
							lista={ListComponentProps.lstListaPaginada}
							paginacao={ListComponentProps.lstPaginacao}
							pageNumber={isNull(ListComponentProps.lstPageNumber) || isUndefined(ListComponentProps.lstPageNumber) ? 1 : ListComponentProps.lstPageNumber}
							rowsPerPage={isNull(ListComponentProps.lstRowsPerPage) || isUndefined(ListComponentProps.lstRowsPerPage) ? 20 : ListComponentProps.lstRowsPerPage}
							rowsPerPageOptions={isNull(ListComponentProps.lstRowsPerPageOptions) || isUndefined(ListComponentProps.lstRowsPerPageOptions) ? [5,10,20,50,100] : ListComponentProps.lstRowsPerPageOptions}
							setup={ListComponentProps.lstSetup}
							action={userRoleAdmin ? isAcao ? lstAction : lstActionIsView : lstActionVisualizar}
							callback={ListComponentProps.lstCallback}
							handleFilter={ListComponentProps.lstCallbackFilter ? (event, filter, orderBy) => ListComponentProps.lstCallbackFilter(event, filter, orderBy) : undefined}
							orderHeranca={ListComponentProps.lstOrderHeranca}
							orderByHeranca={ListComponentProps.lstOrderByHeranca}
						/>

						{/* Aqui é onde os elementos adicionais serão renderizados */}
						{ListComponentProps.children}
					</Paper>
				</Grid>
			</Grid>
		</Container>
		</>
	);
}
export default ListComponent;
